import { IAPIErrorResponse } from "../../Data/Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IResponseDepoimentos } from "../../Data/Interfaces/Responses/Depoimentos/IResponseDepoimentos";
import { createAction, Action, ActionsUnion } from "../../Utils/actionHelpers";

export enum DepoimentosActionKeys {
  SAVE_DEPOIMENTOS_SUCCESS = "SAVE_DEPOIMENTOS_SUCCESS",
  SAVE_DEPOIMENTOS_FAILED = "SAVE_DEPOIMENTOS_FAILED",
  NEXT_DEPOIMENTO_SUCCESS = "NEXT_DEPOIMENTO_SUCCESS",

  SET_LOADING = "SET_LOADING",
}

export const DepoimentosActions = {
  saveDepoimentossSuccess: (
    data: IResponse<IResponseDepoimentos[]>
  ): SaveDepoimentosSuccessAction =>
    createAction(DepoimentosActionKeys.SAVE_DEPOIMENTOS_SUCCESS, data),
  saveDepoimentossFailed: (
    data: IAPIErrorResponse
  ): SaveDepoimentosFailedAction =>
    createAction(DepoimentosActionKeys.SAVE_DEPOIMENTOS_FAILED, data),

  setLoading: (isLoading: boolean): StartLoadingAction =>
    createAction(DepoimentosActionKeys.SET_LOADING, isLoading),

  nextDepoimento: (): NextDepoimentoAction =>
    createAction(DepoimentosActionKeys.NEXT_DEPOIMENTO_SUCCESS),
};

export type DepoimentosActionUnion = ActionsUnion<typeof DepoimentosActions>;

export type NextDepoimentoAction =
  Action<DepoimentosActionKeys.NEXT_DEPOIMENTO_SUCCESS>;

export type SaveDepoimentosSuccessAction = Action<
  DepoimentosActionKeys.SAVE_DEPOIMENTOS_SUCCESS,
  IResponse<IResponseDepoimentos[]>
>;

export type SaveDepoimentosFailedAction = Action<
  DepoimentosActionKeys.SAVE_DEPOIMENTOS_FAILED,
  IAPIErrorResponse
>;

export type StartLoadingAction = Action<
  DepoimentosActionKeys.SET_LOADING,
  boolean
>;
